module.exports = __webpack_public_path__ + "img/img-3.8fed6769.png";